import { initReveal } from '@theme/components/reveal.js';
import Collapse from 'bootstrap/js/dist/collapse';
import Modal from 'bootstrap/js/dist/modal';

window.bootstrap = window.bootstrap || {};
window.bootstrap.Collapse = Collapse;
window.Collapse = Collapse;


import { initHeader } from '@theme/components/header.js';
import { initHeroSwipers } from '@theme/components/hero-swiper.js';
import { initUspSwipers, initTrustpilotBarSwipers } from '@theme/components/usp-swiper.js';
import { initLogosSwipers } from '@theme/components/logos-swiper.js';
import { initReviewsSwipers } from '@theme/components/testimonial-google.js';
import { initPostsSwipers } from '@theme/components/posts-swiper.js';
import { initStatsCounters } from '@theme/components/our-numbers.js';
import { initEventsSwipers } from '@theme/components/events-swiper.js';
import { initTeamSwipers } from '@theme/components/team-swiper.js';
import { initLocationsSwipers } from '@theme/components/locations-swiper.js';
import { initCollectionSwipers } from '@theme/components/collection-swiper.js';
import { initAccount } from '@theme/components/account.js';
import { initBlogFilters } from '@theme/components/blog.js';
import { initVideosSwipers } from '@theme/components/videos-swiper.js';
import { initPopularProductsTabs } from '@theme/components/popular-products-swiper.js';
import { initVideoFull } from '@theme/components/video-full.js';
import { initMiniCart } from '@theme/components/mini-cart.js';
import { initQuoteModal } from '@theme/components/modal-quote.js';
import { initOgoComparison } from '@theme/components/ogo-comparison.js';
import { initProduct } from '@theme/components/product.js';
import { initAccordions } from '@theme/components/accordions.js';




let __modalsBound = false;
function initModalsOnce() {
  if (__modalsBound) return;
  __modalsBound = true;

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-bs-toggle="modal"]');
    if (opener) {
      e.preventDefault();
      const sel = opener.getAttribute('data-bs-target') || opener.getAttribute('href');
      if (!sel) return;
      const el = document.querySelector(sel);
      if (el) Modal.getOrCreateInstance(el).show();
      return;
    }
    const closer = e.target.closest('[data-bs-dismiss="modal"], .btn-close');
    if (closer) {
      const modalEl = closer.closest('.modal');
      if (modalEl) Modal.getOrCreateInstance(modalEl).hide();
    }
  });
}

let __externalLinksListenerBound = false;
function initExternalLinks(scope = document) {
  const links = scope.querySelectorAll('a[href]');
  links.forEach((link) => {
    const href = link.getAttribute('href').trim();
    if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('//')) {
      try {
        const url = new URL(href, window.location.origin);
        if (url.hostname !== window.location.hostname) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      } catch (err) {
        // Ignore invalid URLs
      }
    }
  });

  if (!__externalLinksListenerBound) {
    __externalLinksListenerBound = true;
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href').trim();
      if (href.startsWith('http://') || href.startsWith('https://') || href.startsWith('//')) {
        try {
          const url = new URL(href, window.location.origin);
          if (url.hostname !== window.location.hostname) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
          }
        } catch (err) {
          // Ignore invalid URLs
        }
      }
    });
  }
}

function boot(e) {
  const scope = e?.target || document;

  initModalsOnce();
  initExternalLinks(scope);

  initHeader(Collapse);
  initHeroSwipers(scope);
  initUspSwipers(scope);
  initLogosSwipers(scope);
  initReviewsSwipers(scope);
  initPostsSwipers(scope);
  initStatsCounters(scope);
  initEventsSwipers(scope);
  initTeamSwipers(scope);
  initLocationsSwipers(scope);
  initVideosSwipers(scope);
  initPopularProductsTabs(scope);
  initCollectionSwipers(scope);
  initAccount(scope);
  initBlogFilters(scope);
  initVideoFull(scope);
  initOgoComparison(scope);
  initReveal(scope);
  initMiniCart(scope);
  initQuoteModal(scope);
  initProduct(scope);
  initAccordions(scope);
  initTrustpilotBarSwipers();
}

document.addEventListener('DOMContentLoaded', boot);
[
  'shopify:section:load',
  'shopify:section:select',
  'shopify:section:deselect',
  'shopify:section:reorder',
  'shopify:block:select',
  'shopify:block:deselect',
  'page:load',
  'pageshow'
].forEach((evt) => document.addEventListener(evt, boot));
